import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { APPRAISAL_PRODUCTS_ACTION_TYPE } from '../actions';

const initialState = {
  appraisalProducts: {},
  mercuryProducts: [],
  reggoraProducts: [],
  homeVisionJobTypes: [],
};

const appraisalProductsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case APPRAISAL_PRODUCTS_ACTION_TYPE.GET_APPRAISAL_PRODUCTS:
        draft.appraisalProducts = payload || initialState.appraisalProducts;
        break;

      case APPRAISAL_PRODUCTS_ACTION_TYPE.GET_APPRAISAL_PRODUCT_CATALOGS:
        draft.mercuryProducts = payload.mercuryProducts || initialState.mercuryProducts;
        draft.reggoraProducts = payload.reggoraProducts || initialState.reggoraProducts;
        draft.homeVisionJobTypes = payload.homeVisionJobTypes || initialState.homeVisionJobTypes;
        break;

      case APPRAISAL_PRODUCTS_ACTION_TYPE.CREATE_APPRAISAL_PRODUCT:
      case APPRAISAL_PRODUCTS_ACTION_TYPE.UPDATE_APPRAISAL_PRODUCT:
        draft.appraisalProducts[payload.id] = payload;
        break;

      case APPRAISAL_PRODUCTS_ACTION_TYPE.DELETE_APPRAISAL_PRODUCT:
        delete draft.appraisalProducts[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default appraisalProductsReducer;
